<div *ngIf="data">

    <!-- Page Banner -->
    <div class="page-banner-area ptb-100" style="background-image: url({{data.pageBannerBgImage.data.attributes.url}});">
        <div class="container">
            <div class="page-banner-content">
                <h2>{{data.pageBannerTitle}}</h2>
                <ul>
                    <li>
                        <a routerLink="/">
                            Accueil
                        </a>
                    </li>
                    <li>{{data.pageBannerTitle}}</li>
                </ul>
            </div>
        </div>
    </div>
    
    <!-- Our Hosts -->
    <div class="hosts-area pt-100 pb-75">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-3 col-sm-6" *ngFor="let content of data.ourHostsLists">
                    <div class="single-hosts-card">
                        <div class="hosts-image">
                            <img [src]="content.image.data.attributes.url" alt="host-image">
                        </div>
                        <div class="hosts-content">
                            <h3>{{content.name}}</h3>
                            <span>{{content.designation}}</span>
                        </div>
                        <ul class="hosts-social">
                            <li *ngFor="let item of content.social">
                                <a href="{{item.link}}" target="_blank">
                                    <i class="{{item.icon}}"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>